export type SetPickedIds = (value: string[]) => void;
type SyncIds = (ids: string[]) => Promise<unknown>;

export type SelectionSyncAdapter = {
    setPickedIds?: SetPickedIds;
    syncAddIds?: SyncIds;
    syncRemoveIds?: SyncIds;
    clearSelection?: () => Promise<unknown>;
    setSelection?: SyncIds;
};

export const createLocalSelectionSyncAdapter = ({
    setPickedIds,
}: {
    setPickedIds?: SetPickedIds;
}): SelectionSyncAdapter => ({
    setPickedIds,
});

export const createSessionSelectionSyncAdapter = ({
    sessionId,
    setPickedIds,
    syncAddIds,
    syncRemoveIds,
    clearSelection,
    setSelection,
}: {
    sessionId: string;
    setPickedIds?: SetPickedIds;
    syncAddIds?: SyncIds;
    syncRemoveIds?: SyncIds;
    clearSelection?: () => Promise<unknown>;
    setSelection?: SyncIds;
}): SelectionSyncAdapter => {
    if (!sessionId) {
        return {};
    }

    return {
        setPickedIds,
        syncAddIds,
        syncRemoveIds,
        clearSelection,
        setSelection,
    };
};
